export enum SnackbarMessages {
    USER_CREATED = 'New User Successfully Created',
    USER_CREATED_F = 'New User Creation Failed!',
    USER_UPDATED = 'User Successfully Updated',
    USER_UPDATED_F = 'User Updation Failed!',
    CLIENT_CREATED = 'New Client Successfully Created',
    CLIENT_CREATED_F = 'New Client Creation Failed!',
    CLIENT_UPDATED = 'Client Successfully Updated',
    CLIENT_UPDATED_F = 'Client Updation Failed!',
    TASK_CREATED = 'New Task Successfully Created',
    TASK_CREATED_F = 'New Task Creation Failed!',
    TASK_UPDATED = 'Task Successfully Updated',
    TASK_UPDATED_F = 'Task Updation Failed!',
    TASK_DEACTIVATED = 'Task Successfully Deactivated',
    TASK_DEACTIVATED_F = 'Task Deactivation Failed!',
    TASK_ACTIVATED = 'Task Successfully Activated',
    TASK_ACTIVATED_F = 'Task Activation Failed!',
    TASK_DELETED = 'Task Successfully Deleted',
    TASK_DELETED_F = 'Task Deletion Failed!',
    TASK_LOADING_F = 'Loading Tasks Failed!',
    PROJECT_CREATED = 'New Project Successfully Created',
    PROJECT_CREATED_F = 'New Project Creation Failed!',
    PROJECT_UPDATED = 'Project Successfully Updated',
    PROJECT_UPDATED_F = 'Project Updation Failed!',
    CATEGORY_CREATED = 'New Category Successfully Created',
    CATEGORY_CREATED_F = 'New Category Creation Failed!',
    CATEGORY_DELETED = 'Categories Cannot Be Deleted Directly, Please Request Deletion If Needed!',
    DOCUMENT_CREATED = 'New Document Successfully Created',
    DOCUMENT_CREATED_F = 'New Document Creation Failed!',
    DOCUMENT_DELETED = 'Document Successfully Deleted',
    DOCUMENT_DELETED_F = 'Document Deletion Failed!',
    WORK_ORDER_CREATED = 'New Work Order Successfully Created',
    WORK_ORDER_CREATED_F = 'New Work Order Creation Failed!',
    WORK_ORDER_UPDATED = 'Work Order Successfully Updated',
    WORK_ORDER_UPDATED_F = 'Work Order Updation Failed!',
    ROLE_CREATED = 'New Role Successfully Created',
    ROLE_CREATED_F = 'New Role Creation Failed!',
    ROLE_UPDATED = 'Role Successfully Updated',
    ROLE_UPDATED_F = 'Role Updation Failed!',
    ROLE_DEACTIVATED = 'Role Successfully Deactivated',
    ROLE_DEACTIVATED_F = 'Role Deactivation Failed!',
    ROLE_ACTIVATED = 'Role Successfully Activated',
    ROLE_ACTIVATED_F = 'Role Activation Failed!',
    TIMESHEET_SAVED = 'Timesheet Successfully Saved',
    TIMESHEET_SAVED_F = 'Timesheet Save Failed',
    TIMESHEET_SUBMITTED = 'Timesheet Successfully Submitted',
    TIMESHEET_SUBMITTED_F = 'Timesheet Submission Failed',
    EMPLOYEE_TYPE_CREATED = 'New Employee Type Successfully Created',
    EMPLOYEE_TYPE_CREATED_F = 'New Employee Type Creation Failed!',
    EMPLOYEE_TYPE_UPDATED = 'Employee Type Successfully Updated',
    EMPLOYEE_TYPE_UPDATED_F = 'Employee Type Updation Failed!',
    FILE_INVALID_TYPE = 'Invalid file type. Allowed file types are JPEG and PNG.',
    FILE_SIZE_LIMIT_EXCEEDED = 'File size exceeds allowed limit of 8 MB.',
    FILE_LOAD_IMAGE_F = 'Failed to load image',
    FILE_EXPORT_F = 'There was an error retrieving the file from the server',
    DATA_F = 'There was an error retrieving data from the server',
    USER_PROFILE_DATA_F = 'There was an error retrieving user profile data',
    AI_CHAT_THREADS_F = 'There was an error retrieving your AI chats',
    AI_CHAT_DELETE_F = 'There was an error deleting this chat',
    AI_CHAT_MESSAGE_F = 'There was an error sending your message to the AI',
    AI_CHAT_THREAD_LOAD_F = 'There was an error loading this chat',
    AI_CHAT_THREAD_SAVE_F = 'There was an error saving this chat',
}

export enum SnackBarDefaultConfig {
    DURATION = 3000,
    ACTION = 'Close',
    VERTICAL_POSITION = 'top',
    HORIZONTAL_POSITION = 'center',
}
